module.exports = __webpack_public_path__ + "static/media/voga1.3b0aeba1.jpg";